
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { compose } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { TextField } from './ReduxFormMaterialUI'

import { indigo } from '@material-ui/core/colors'
import red from '@material-ui/core/colors/red'
import { Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import PageContainer from './PageContainer'
import ProgressButton from './buttons/ProgressButton'

import { upper } from '../utilities/normalizers'
import config from '../config'


class LoginInternal extends Component {
  constructor (props) {
    super(props);
  };
  componentDidMount() {
    this.props.setInitialLogin()
    const { mfaAuthenticate } = this.props;
    const environment = process.env.REACT_APP_ENV
    const env = window.location.href
    const client_id = config.CLIENT_ID
   
    let url = new URL(env);
    let redurl = url.origin + url.pathname;

    let oldLogin = false

    const authParamsSansUri = '?client_id='  
    + client_id + '&response_type=code&scope=openid%20profile%20email%20groups&state=nonce&max_age=0'

    let authUriEncoded = '&redirect_uri=' + encodeURIComponent(env)
    console.log('authUriEncoded2=' + authUriEncoded)

    const authBaseUrl = config.OKTA_URL
    //const authBaseUrl = 'https://login-dev.usps.gov/oauth2/aus51xxazjYoRO1Lv4h7/v1/authorize'
    //https://login-dev.usps.gov/oauth2/aus51xxazjYoRO1Lv4h7
    let authUrl = authBaseUrl + authParamsSansUri + authUriEncoded
     
    let authCode = null
    try {
      const params = new URLSearchParams(window.location.search)
      authCode = params.get('code')
    } catch (error) {
      console.log(error)
      authCode = null
    }
    if (authCode == null) {
      window.location.href = authUrl
    } else {
      this.props.mfaAuthenticate(authCode, redurl).then((msg) => {
        if (msg && msg.includes('User Found')) {
        setTimeout(() => {
        this.props.history.push('/home')
        }, 500)
        }
      })
    }
  }

  render() {
    return <div></div>
  }
  }


export default LoginInternal
